import PropTypes from 'prop-types';
import React from 'react';
import Star from './Star';
import MicIcon from '../../images/vector/mic.svg';
import { TRO } from '../../constants/measure';

const PlaylistItem = ({ index, name, measure, isComplete }) => (
    <div className="measure">
        <Star index={index} isFilled={isComplete} />
        <div className="measure-name">
            <div className="content">
                {measure === TRO.MEASURE && <MicIcon />}
                <span className="text">{name}</span>
            </div>
        </div>
    </div>

);

PlaylistItem.propTypes = {
    name: PropTypes.string.isRequired,
    measure: PropTypes.string,
    index: PropTypes.number.isRequired,
    isComplete: PropTypes.bool,
};

PlaylistItem.defaultProps = {
    isComplete: false,
    measure: '',
};

export default PlaylistItem;
